var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWineComfirmError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 105,
    viewBox: "0 0 108 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 52.5,
    rx: 54,
    ry: 52.5,
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.644 65.1348L60.8134 53.0008L72.644 40.8669C72.8718 40.6321 72.9997 40.3144 72.9997 39.9832C72.9997 39.652 72.8718 39.3343 72.644 39.0996L67.0548 33.3658C66.8258 33.1325 66.5161 33.0015 66.1933 33.0015C65.8704 33.0015 65.5607 33.1325 65.3317 33.3658L53.5062 45.4998L41.6692 33.3658C41.4404 33.1322 41.1306 33.001 40.8077 33.001C40.4848 33.001 40.175 33.1322 39.9461 33.3658L34.3557 39.0983C34.1279 39.333 34 39.6507 34 39.9819C34 40.3131 34.1279 40.6308 34.3557 40.8656L46.1863 52.9995L34.3557 65.1348C34.1279 65.3695 34 65.6872 34 66.0184C34 66.3496 34.1279 66.6673 34.3557 66.9021L39.9448 72.6345C40.1737 72.8682 40.4835 72.9994 40.8064 72.9994C41.1293 72.9994 41.4391 72.8682 41.668 72.6345L53.5062 60.4993L65.3368 72.6332C65.5656 72.8669 65.8754 72.9981 66.1983 72.9981C66.5212 72.9981 66.831 72.8669 67.0599 72.6332L72.649 66.9008C72.8768 66.666 73.0047 66.3483 73.0047 66.0171C73.0047 65.6859 72.8768 65.3682 72.649 65.1335L72.644 65.1348Z",
    fill: "#1FE85C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 40,
    fill: "white",
    transform: "translate(34 33)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineComfirmError);
export default __webpack_public_path__ + "static/media/wine-comfirm-error.9c2f9c67f5380b45a9786efab0ce5bf5.svg";
export { ForwardRef as ReactComponent };